import React from 'react'

import { withRouter } from 'react-router-dom'

import { Chart } from 'primereact/chart';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Badge } from 'primereact/badge';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Calendar } from 'primereact/calendar'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import NavBar from '../../componentes/Navbar'

import GraficoAtividadeService from '../../app/service/GraficoAtividadeService'
import FinanceiroService from '../../app/service/FinanceiroService'
import UsuarioService from '../../app/service/UsuarioService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './grafico.css'
import '../processo/processo.css'

class GraficoAtividades extends React.Component {
  constructor(props) {
    super(props);

    this.graficoAtividadeService = new GraficoAtividadeService();
    this.financeiroService = new FinanceiroService();
    this.usuarioService = new UsuarioService();

    this.statusPontuacaoUsuario = this.statusPontuacaoUsuario.bind(this);
    this.linkConcluidas = this.linkConcluidas.bind(this);
    this.linkCriadas = this.linkCriadas.bind(this);

    this.state = {
      meses: [],
      graficoAtividades: [],
      graficoAtividadesData: null,
      graficoAtividadesDataLimite: [],
      graficoAtividadesConcluido: [],
      graficoAtividadesDataLImiteConcluidoData: null,
      graficoStatus: [],
      graficoStatusData: null,
      graficoSituacaoEmpresa: [],
      graficoSituacaoEmpresaData: null,
      detail: '',
      openSpinner: false,
      //Grupos de Trabalho
      graficoAtividadeGrupo: [],
      graficoAtividadeGrupoPie: null,
      //Fases
      graficoAtividadeFases: [],
      graficoAtividadeFasesPie: null,
      layout: 'list',
      //Consulta
      dataInicialGeral: '',
      dataFinalGeral: '',
      dataInicialUsuario: '',
      dataFinalUsuario: '',
      paramGraficoUsuario: '',
      dataInicialPontuacaoUsuario: '',
      dataFinalPontuacaoUsuario: '',
      modalLoad: '',
      //Grafico Pontuação Total
      pontuacaoTotal: null,
      optionChart: null,
      pontuacaoAcumulada: null,
      //Dados pontuação Usuários
      usuariosPontuacao: [],
      linkUsuario: '',
      dataUsuarioInicial: '',
      dataUsuarioFinal: '',
      //Ranking
      ranking: [],
      graficoRanking: null,
    };

    this.kleiton = {
      maintainAspectRatio: false,
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  color: '#495057'
              }
          }
      },
    }

    this.options = this.getLightTheme();
  }

  listarMeses = async () => {
    await this.financeiroService.listarMeses()
      .then(response => {
        this.setState({meses: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Meses', detail:`${this.state.detail}`, life: 4000});
      })
  }

  ativdadesStatus = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado

    await this.graficoAtividadeService.graficoAtividadesStatus(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoStatus: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      let status = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        status.push(this.state.graficoStatus[i].status);
      }

      let totais = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        totais.push(this.state.graficoStatus[i].total);
      }

      await this.setState({graficoStatusData: {
        labels: status,
        datasets: [
          {
            data: totais,
            backgroundColor: [
              "#42A5F5",
              "#66BB6A",
              "#FFA726",
              "#BBCCCC",
              "#FF0000"
            ],
          }
        ]
      }});
  }

  atividadesDataLimiteConcluidas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    await this.graficoAtividadeService.graficoDataLimite(usuarioLogado.empresa.codigo, '2022-01-01', '2022-12-31')
      .then(response => {
        this.setState({graficoAtividadesDataLimite: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

    await this.graficoAtividadeService.graficoDataConcluido(usuarioLogado.empresa.codigo, '2022-01-01', '2022-12-31')
      .then(response => {
        this.setState({graficoAtividadesConcluido: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

    let nomeMeses = [];
    for(let i = 0; i < this.state.meses.length; i++) {
      nomeMeses.push(this.state.meses[i].mes);
    }

    let dataLimite = [];
    for(let i = 0; i < this.state.graficoAtividadesDataLimite.length; i++) {
      dataLimite.push(this.state.graficoAtividadesDataLimite[i].total);
    }

    let concluidos = [];
    for(let i = 0; i < this.state.graficoAtividadesConcluido.length; i++) {
      concluidos.push(this.state.graficoAtividadesConcluido[i].total);
    }

    await this.setState({graficoAtividadesDataLImiteConcluidoData: {
      labels: nomeMeses,
      datasets: [
        {

          label: 'Data Limite',
          backgroundColor: '#FF0000',
          data: dataLimite

        },
        {

          label: 'Concluídas',
          backgroundColor: '#008000',
          data: concluidos

        }
      ]
    }})
  }

  atividadesCriadas = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.graficoAtividadeService.graficoTotal(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoAtividades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      })

    let nomeMeses = [];
    for(let i = 0; i < this.state.meses.length; i++) {
      nomeMeses.push(this.state.meses[i].mes);
    }

    let atividades = [];
    for(let i = 0; i < this.state.graficoAtividades.length; i++) {
      atividades.push(this.state.graficoAtividades[i].total);
    }

    await this.setState({graficoAtividadesData: {
      labels: nomeMeses,
      datasets: [
        {

          label: 'Atividades',
          backgroundColor: '#008000',
          data: atividades
        }
      ]
    }})
  }

  graficosAtividadesSituacao = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.graficoAtividadesSituacao(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoSituacaoEmpresa: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });
    
    let valores = [];
    for(let i = 0; i < this.state.graficoSituacaoEmpresa.length; i++) {
      valores.push(this.state.graficoSituacaoEmpresa[i].atrasados);
      valores.push(this.state.graficoSituacaoEmpresa[i].concluidosAtrasados);
      valores.push(this.state.graficoSituacaoEmpresa[i].concluidosPrazo);
    }  

    await this.setState({graficoSituacaoEmpresaData: {
      labels: ['Atrasados', 'Concl. Atraso', 'Concl. Prazo'],
      datasets: [
        {
          data: [this.state.graficoSituacaoEmpresa[0].atrasados, 
                 this.state.graficoSituacaoEmpresa[0].concluidosAtrasados,
                 this.state.graficoSituacaoEmpresa[0].concluidosPrazo],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ]
        }
      ]
    }})
  }

  graficoAtividadeGrupo = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.graficoAtividadeGrupo(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoAtividadeGrupo: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      //Grupos
      let grupos = [];
      for(let i = 0; i < this.state.graficoAtividadeGrupo.length; i++) {
        grupos.push(this.state.graficoAtividadeGrupo[i].grupo);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.graficoAtividadeGrupo.length; i++) {
        cores.push(this.state.graficoAtividadeGrupo[i].cor);
      }

      //Total
      let valores = [];
      for(let i = 0; i < this.state.graficoAtividadeGrupo.length; i++) {
        valores.push(this.state.graficoAtividadeGrupo[i].total);
      }

      await this.setState({graficoAtividadeGrupoPie: {
        labels: grupos,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  graficoAtividadeFase = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.graficoFaseProcessoAtividade(usuarioLogado.empresa.codigo,
      dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoAtividadeFases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:'Erro ao gerar Gráfico de Atividades por Fase Processual', life: 4000});
      });

      //Fases
      let fases = [];
      for(let i = 0; i < this.state.graficoAtividadeFases.length; i++) {
        fases.push(this.state.graficoAtividadeFases[i].fase);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.graficoAtividadeFases.length; i++) {
        cores.push(this.state.graficoAtividadeFases[i].cor);
      }

      //Total
      let valores = [];
      for(let i = 0; i < this.state.graficoAtividadeFases.length; i++) {
        valores.push(this.state.graficoAtividadeFases[i].atividades);
      }

      await this.setState({graficoAtividadeFasesPie: {
        labels: fases,
        datasets: [
          {
            data: valores,
            label: 'Fases',
            backgroundColor: cores,
          }
        ]
      }});
  }

  graficoPontuacaoAcumulada = async (data) => {
    //Nome
    let nomes = [];
    for(let i = 0; i < data.acumulado.length; i++) {
      nomes.push(data.acumulado[i].nome);
    }
    //Cores
    let cores = [];
    for(let i = 0; i < data.acumulado.length; i++) {
      cores.push(data.acumulado[i].cor);
    }

    //Pontos
    let pontos = [];
    for(let i = 0; i < data.acumulado.length; i++) {
      pontos.push(data.acumulado[i].pontos);
    }

    await this.setState({pontuacaoAcumulada: {
      labels: nomes,
      datasets: [
        {
          data: pontos,
          label: '',
          //label: `Pontuação - ${data.percentual}%  Alcançados`,
          backgroundColor: cores
        }
      ]
    }});
  }

  graficoPontuacaoTotal = async (dataInicial,dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const documentStyle = getComputedStyle(document.documentElement);
    await this.graficoAtividadeService.graficoPontuacaoTotal(usuarioLogado.empresa.codigo,dataInicial,dataFinal)
      .then(response => {
        this.setState({pontuacaoTotal: response.data});
        const dias = [];
          for(let i = 0; i < response.data.pontuacaoProjecao.length; i++) {
            dias.push(response.data.pontuacaoProjecao[i].dias);
          }

          let datasets = [];
          
          let pontosProjecao = [];
          for(let i = 0; i < response.data.pontuacaoProjecao.length; i++) {
            pontosProjecao.push(response.data.pontuacaoProjecao[i].pontos);
          }

          const projecao = {
            label: 'Total Projeção',
            data: pontosProjecao,
            fill: true,
            tension: 0.4,
            borderColor: documentStyle.getPropertyValue('--green-500'),
            backgroundColor: 'rgba(255,255,255,0.3)'
          }
          datasets.push(projecao);

          let pontosUsuarios = [];
          for(let i = 0; i < response.data.pontuacaoUsuarios.length; i++) {
            pontosUsuarios.push(response.data.pontuacaoUsuarios[i].pontos);
          }

          const usuarios = {
            label: 'Total Usuários',
            data: pontosUsuarios,
            fill: true,
            borderDash: [5, 5],
            tension: 0.4,
            borderColor: documentStyle.getPropertyValue('--blue-500'),
            backgroundColor: 'rgba(255,255,255,0.3)'
          }
          datasets.push(usuarios);

          const data = {
            labels: dias,
            datasets: datasets
          };

          this.setState({pontuacaoTotal: data})
          this.graficoPontuacaoAcumulada(response.data);
      })
  }

  pontuacaoUsuariosDados = async (dataInicial,dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.pontuacaoUsuariosDados(usuarioLogado.empresa.codigo,
      dataInicial,dataFinal)
      .then(response => {
        this.setState({pontuacaoUsuarios: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  consultarAtividadesRanking = async (dataInicial,dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.consultarAtividadesRanking(usuarioLogado.empresa.codigo,dataInicial,dataFinal)
      .then(response => {
        this.setState({ranking: response.data});
        this.rankingAtividadesGrafico(response.data);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  rankingAtividadesGrafico = (data) => {
      //Atividades
      let atividades = [];
      for(let i = 0; i < data.length; i++) {
        atividades.push(data[i].atividade);
      }

      //Cores
      let cores = [];
      for(let i = 0; i < data.length; i++) {
        cores.push(data[i].cor);
      }

      //Quantidades
      let quantidades = [];
      for(let i = 0; i < data.length; i++) {
        quantidades.push(data[i].atividades);
      }

      this.setState({graficoRanking: {
        labels: atividades,
        datasets: [
          {
            data: quantidades,
            backgroundColor: cores,
          }
        ]
      }});
  }

  statusPontuacaoUsuario(rowData) {
    var icon = '';
    var title = '';
    if(rowData.status == 'Meta Alcançada') {
      icon = "fas fa-smile";
      title = 'Meta alcançada';
    } else if(rowData.status == 'Em andamento') {
      icon = "fas fa-hourglass-half";
      title = 'Em andamento';
    } else {
      icon = "fas fa-frown";
      title = 'Meta não alcançada';
    }

    return(
      <React.Fragment>
        <i title={title} className={icon}></i>
      </React.Fragment>
    );
  }

  linkConcluidas(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.consultardesempenhoUsuario(rowData,'C')} 
           href={this.state.linkUsuario}
           target="_blank"
           style={{color: 'blue', cursor: 'pointer'}} 
           title="Detalhar atividades">{rowData.atividadesConcluidas}</a>
      </React.Fragment>
    );
  }

  linkCriadas(rowData) {
    return(
      <React.Fragment>
        <a style={{color: 'blue', cursor: 'pointer'}} title="Detalhar atividades">{rowData.atividadesCriadas}</a>
      </React.Fragment>
    );
  }

  alterarDataPontuacaoUsuario = async () => {
    if(this.state.dataInicialPontuacaoUsuario == '' || this.state.dataInicialPontuacaoUsuario == null) {
      this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:'Informe a data inicial para a pesquisa', life: 4000});
      return;
    }

    if(this.state.dataFinalPontuacaoUsuario == '' || this.state.dataFinalPontuacaoUsuario == null) {
      this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:'Informe a data inicial para a pesquisa', life: 4000});
      return;
    }

    var dateInicial = this.state.dataInicialPontuacaoUsuario;
    var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
    var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
    var yearInicial= dateInicial.getFullYear();
    var dataInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;

    var dateFinal = this.state.dataFinalPontuacaoUsuario;
    var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
    var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
    var yearFinal= dateFinal.getFullYear();
    var dataFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    
    this.setState({openSpinner: true});
    await this.pontuacaoUsuariosDados(dataInicial,dataFinal);
    this.setState({openSpinner: false});
  }

  configGraficoPontuacao = async () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    const optionsChart = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
          legend: {
              labels: {
                  color: textColor
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder
              }
          },
          y: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder
              }
          }
      }
    };

    await this.setState({optionsChart: optionsChart});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  consultarGraficos = async () => {
    this.setState({openSpinner: true});
    await this.listarMeses();
  
    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicialGeral != '') {
      var date = this.state.dataInicialGeral;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinalGeral != '') {
      var date = this.state.dataFinalGeral;
      var month = this.pad2(date.getMonth()+1);//months (0-11) kleiton
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }  

    //await this.atividadesCriadas(dataFormatadaInicial,dataFormatadaFinal);kleiton
    await this.ativdadesStatus(dataFormatadaInicial,dataFormatadaFinal);
    await this.graficoAtividadeFase(dataFormatadaInicial,dataFormatadaFinal);
    await this.graficoAtividadeGrupo(dataFormatadaInicial, dataFormatadaFinal);
    await this.graficosAtividadesSituacao(dataFormatadaInicial, dataFormatadaFinal);


    await this.configGraficoPontuacao(dataFormatadaInicial,dataFormatadaFinal);
    await this.graficoPontuacaoTotal(dataFormatadaInicial,dataFormatadaFinal);
    await this.pontuacaoUsuariosDados(dataFormatadaInicial,dataFormatadaFinal);
    await this.consultarAtividadesRanking(dataFormatadaInicial,dataFormatadaFinal);


    this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarMeses();

    
    // Obter a data atual
    var dataAtual = new Date();

    // Definir a data para o primeiro dia do mês atual
    var primeiroDiaMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);

    // Definir a data para o último dia do mês atual
    var ultimoDiaMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);

    // Formatar as datas para o formato "AAAA-MM-DD"
    var primeiroDiaFormatado = primeiroDiaMes.toISOString().split('T')[0];
    var ultimoDiaFormatado = ultimoDiaMes.toISOString().split('T')[0];

    var dataInicial = new Date(primeiroDiaFormatado);
    dataInicial.setDate(dataInicial.getDate()+1)

    var dataFinal = new Date(ultimoDiaFormatado);
    dataFinal.setDate(dataFinal.getDate()+1)


    this.setState({dataInicialGeral: dataInicial});
    this.setState({dataFinalGeral: dataFinal});
    //Para pesquisa de usuários individualizados
    this.setState({dataUsuarioInicial: primeiroDiaFormatado});
    this.setState({dataUsuarioFinal: ultimoDiaFormatado});

    await this.atividadesCriadas('2024-01-01','2024-12-31');
    await this.ativdadesStatus(primeiroDiaFormatado,ultimoDiaFormatado);
    await this.graficoAtividadeFase(primeiroDiaFormatado,ultimoDiaFormatado);
    await this.configGraficoPontuacao(primeiroDiaFormatado,ultimoDiaFormatado);
    await this.graficoPontuacaoTotal(primeiroDiaFormatado,ultimoDiaFormatado);
    await this.pontuacaoUsuariosDados(primeiroDiaFormatado,ultimoDiaFormatado);
    await this.consultarAtividadesRanking(primeiroDiaFormatado,ultimoDiaFormatado);
    await this.graficoAtividadeGrupo(primeiroDiaFormatado,ultimoDiaFormatado);
    await this.graficosAtividadesSituacao(primeiroDiaFormatado,ultimoDiaFormatado);
    this.setState({openSpinner: false});
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }

  consultardesempenhoUsuario(atividade,tipoConsulta){
    this.setState({linkUsuario: `#/desempenhoUsuario/${atividade.codigoUsuario}/${this.state.dataUsuarioInicial}/${this.state.dataUsuarioFinal}/${tipoConsulta}`});
  }

  refreshPage = () => {
    window.location.reload();
  }

  render() {
    const { basicOptions, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-hand-holding-usd"></i>
                          <span> Gráficos Atividades</span>
                      </h3>  
                    </div>
                    <div className="card-body">

                        <div className="card">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="formGroup">
                                <div style={{padding: '5px'}}>
                                  &nbsp;
                                  &nbsp;
                                  &nbsp;
                                  &nbsp;
                                  <span style={{color: '#cccccc', fontSize: '18px', fontWeight: 'bold', fontStyle: 'italic'}}>
                                    Período
                                  </span>
                                  &nbsp;
                                  &nbsp;
                                  <span style={{textAlign: 'center'}}>
                                    <Calendar id="mask" 
                                              value={this.state.dataInicialGeral} 
                                              onChange={(e) => this.setState({ dataInicialGeral: e.value })} 
                                              locale="es"
                                              style={{height: '32px', width: '145px'}} 
                                              dateFormat="dd/mm/yy"
                                              mask="99/99/9999"/>
                                      &nbsp;
                                    <Calendar id="mask" 
                                              value={this.state.dataFinalGeral} 
                                              onChange={(e) => this.setState({ dataFinalGeral: e.value })} 
                                              locale="es"
                                              style={{height: '32px', width: '145px'}} 
                                              dateFormat="dd/mm/yy"
                                              mask="99/99/9999"/>
                                    
                                    &nbsp;
                                    &nbsp;
                                    <Button style={{height: '32px'}} type="button" className="p-button-info p-button-text p-button-sm" 
                                            onClick={this.consultarGraficos}>
                                        <i className="pi pi-filter"></i> &nbsp;Consultar</Button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <Backdrop
                          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                          open={this.state.openSpinner}>
                          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                        </Backdrop>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="formGroup">
                            <div className="card flex justify-content-center">
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Atividades</h5> 
                              </span>
                                <Chart type="bar" data={this.state.graficoAtividadesData} options={basicOptions} />
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="formGroup">
                            <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Situação</h5> 
                              </span>
                                <Chart type="doughnut" data={this.state.graficoSituacaoEmpresaData} />
                            </div>  
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="formGroup">
                            <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Status</h5> 
                              </span>
                                <Chart type="pie" data={this.state.graficoStatusData} />
                            </div>  
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="formGroup">
                            <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Grupo de Trabalho</h5> 
                              </span>
                                <Chart type="pie" data={this.state.graficoAtividadeGrupoPie} />
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="formGroup">
                            <div className="card flex justify-content-center">
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Fases Processuais</h5> 
                              </span>
                                <Chart type="bar" data={this.state.graficoAtividadeFasesPie} options={horizontalOptions} />
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="formGroup">
                            <div className="card flex justify-content-center">
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Principais Atividades</h5> 
                              </span>
                                  <DataTable value={this.state.ranking}>
                                    <Column field="atividade" header="Atividade"></Column>
                                    <Column field="fase" header="Fase"></Column>
                                    <Column field="pontuacao" header="Ponruação"></Column>
                                    <Column field="atividades" header="Qtde. Atividades"></Column>
                                  </DataTable>
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-8">
                          <div className="formGroup">
                            <div className="card flex justify-content-center">
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Pontuação (Projeção X Usuários)</h5> 
                              </span>
                              <Chart style={{height: "297px"}} type="line" data={this.state.pontuacaoTotal} options={this.state.optionsChart} />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="formGroup">
                            <div className="card flex justify-content-center">
                              <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                <h5>Acumulado</h5> 
                              </span>
                              <Chart style={{height: "297px"}} type="bar" data={this.state.pontuacaoAcumulada} options={basicOptions} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="formGroup">
                              <div style={{padding: '5px'}}>
                                <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                  <h5>Usuários</h5> 
                                </span>
                              </div>
                              <DataTable value={this.state.pontuacaoUsuarios}>
                                <Column field="usuario" header="Usuário"></Column>
                                <Column field="pontos" header="Pontos Alcançados"></Column>
                                <Column field="projecao" header="Projetado"></Column>
                                <Column body={this.linkCriadas} exportable={false} header="Atividades Criadas"></Column>
                                <Column body={this.linkConcluidas} exportable={false} header="Atividades Concluídas"></Column>
                                <Column field="percentualTexto" header="Percentual Alcançado"></Column>
                                <Column body={this.statusPontuacaoUsuario} exportable={false} header="Status"></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}

GraficoAtividades.contextType = AuthContext;
export default withRouter (GraficoAtividades)
